// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__CX9lI","back__btn":"styles_back__btn__JwcI7","sider":"styles_sider__In0-l"};